<div class="lds-dual-ring" [ngClass]="{ 'colored': colored }"></div>
